import { render, staticRenderFns } from "./ReadAlertConfiguration.html?vue&type=template&id=f31cb43a&scoped=true&external"
import script from "./ReadAlertConfiguration.js?vue&type=script&lang=js&external"
export * from "./ReadAlertConfiguration.js?vue&type=script&lang=js&external"
import style0 from "./ReadAlertConfiguration.scss?vue&type=style&index=0&id=f31cb43a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31cb43a",
  null
  
)

export default component.exports